import React from "react";
import { NavLink } from "react-router-dom";
import { ReactComponent as ArrowBlue } from "../../../assets/images/arrowblue.svg";
import BatteryPill from "../../../components/battery/battery";

function formatThaiBuddhistDate(value) {
    if (!value) return "";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return String(value);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = String(d.getFullYear() + 543);
    return `${dd}/${mm}/${yyyy}`;
}

export default function ProductCard({ item }) {
    const warrantyText = React.useMemo(() => {
        const warranty = String(item?.warranty || "").trim();
        if (!warranty || warranty === "-" || warranty === "ประกันหมด") return "";
        if (warranty === "ประกันศูนย์") {
            const formattedDate = formatThaiBuddhistDate(item?.warrantyEndDate);
            return formattedDate ? `${warranty} ${formattedDate}` : warranty;
        }
        return warranty;
    }, [item]);

    const showOnsalePrice =
        Boolean(item?.isOnsale) &&
        Number(item?.onsaleDiscount ?? 0) > 0 &&
        Number(item?.onsaleDiscount ?? 0) !== Number(item?.price ?? 0);

    return (
        <div className="group">
            <div className="rounded-2xl overflow-hidden bg-slate-100 aspect-square">
                <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-[1.02] transition no-invert"
                />
            </div>

            <div className="mt-3">
                <div className="font-extrabold text-slate-900 text-sm">{item.title}</div>
                {item.batteryHealth != null && item.batteryHealth !== "" && (
                    <div className="mt-1 flex items-center gap-2 h-[30px] text-xs text-[#6E6E73]">
                        <BatteryPill value={item.batteryHealth} width={49} />
                        <div className="flex flex-col ">
                            <span>{item.usage === "new" && "มือหนึ่ง" || item.usage === "used" && "มือสอง" || "-"}</span>
                            {warrantyText ? <div className="text-xs text-[#6E6E73]">{warrantyText}</div> : null}
                        </div>
                    </div>
                )}
                <div className="text-xs text-[#6E6E73] mt-1">{item.color}</div>
                <div className="text-xs text-[#6E6E73]">{item.capacity}</div>
                <div className="text-xs text-[#6E6E73] mt-1 line-clamp-2">คำอธิบายโดยผู้ดูแล</div>

                <div className="mt-2 flex items-center justify-between border-t border-black/10 pt-2">
                    <div className="flex items-center gap-3">
                        {showOnsalePrice ? (
                            <div className="flex items-center gap-2">
                                <div className="text-xs font-bold text-[#A92B2B] line-through">
                                    ฿{Number(item.price || 0).toLocaleString()}
                                </div>
                                <div className="font-extrabold text-slate-900 text-sm">
                                    ฿{Number(item.onsaleDiscount || 0).toLocaleString()}
                                </div>
                            </div>
                        ) : (
                            <div className="font-extrabold text-slate-900 text-sm">
                                ฿{Number(item.price || 0).toLocaleString()}
                            </div>
                        )}
                    </div>
                    <NavLink
                        to={`/products/${item.id}`}
                        className="text-sm text-[#047DED] font-medium hover:underline"
                    >
                        รายละเอียด <ArrowBlue width={12} height={12} className="inline-block" />
                    </NavLink>
                </div>
            </div>
        </div>
    );
}
